import React, { createContext, useContext } from 'react';
import { useRecaptcha } from '../../hooks/useRecaptcha';

const RecaptchaContext = createContext();

export const useRecaptchaContext = () => {
  const context = useContext(RecaptchaContext);
  if (!context) {
    throw new Error('useRecaptchaContext must be used within a RecaptchaProvider');
  }
  return context;
};

export const RecaptchaProvider = ({ children }) => {
  const recaptcha = useRecaptcha();

  return <RecaptchaContext.Provider value={recaptcha}>{children}</RecaptchaContext.Provider>;
};
